// extracted by mini-css-extract-plugin
export default {"rate":"rate_plan_rate__zV8AT","flexibleContainer":"rate_plan_flexibleContainer__VNmoG"};